import React, { useState, useEffect } from "react";
import PartnerNavbar from "./PartnerNavbar";
import styles from "./css/PartnerLanding.module.css";
import man from "../assets/engMan.png";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Card,
} from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import LoginModal from "../AuthScreen/LoginModal";

const locationData = {
  "Madhya Pradesh": {
    Bhopal: ["Bhopal", "Berasia", "Kolar"],
    Indore: ["Indore", "Depalpur", "Mhow"],
    Gwalior: ["Gwalior", "Dabra", "Bhitarwar"],
  },
  "Uttar Pradesh": {
    Lucknow: ["Lucknow", "Malihabad", "Mohanlalganj"],
    Varanasi: ["Varanasi", "Ramnagar", "Chiraigaon"],
    "Kanpur Nagar": ["Kanpur", "Bithoor", "Ghatampur"],
  },
  // ...add all states/districts/cities here
};
export default function PartnerLanding() {
  const [validated, setValidated] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const [active, setActive] = useState("signIn");

  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");

  const states = Object.keys(locationData);
  const districts = state ? Object.keys(locationData[state]) : [];
  const cities = state && district ? locationData[state][district] : [];
  const [verified, setVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setVerified(true); // reCAPTCHA passed
    } else {
      setVerified(false); // reCAPTCHA cleared or expired
    }
  };

  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleMobileSubmit = (e) => {
    e.preventDefault();
    if (mobile.length === 10) {
      setStep(2); // move to OTP step
    } else {
      alert("Enter a valid 10-digit mobile number");
    }
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (otp.length === 4) {
      setStep(3); // move to name/email step
    } else {
      alert("Enter 4-digit OTP");
    }
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault();
    if (!name || !email) {
      alert("Please fill all fields");
      return;
    }
    alert(
      `Thank you! Form submitted\nName: ${name}\nEmail: ${email}\nMobile: ${mobile}`
    );
    // reset form
    setStep(1);
    setMobile("");
    setOtp("");
    setName("");
    setEmail("");
  };

  return (
    <div className={styles.ladningbg}>
      <PartnerNavbar />
      <div className={styles.container}>
        <div className={styles.containerrow}>
          <div className={styles.containercol1}>
            <div style={{ width: "90%" }}>
              <h1 className={styles.headingoflanding}>
                Earn More. Earn Respect. Safety Ensured
              </h1>
              <p className={styles.partnerJointext}>
                Join 40,000+ partners across India, USA, Singapore, UAE and many
                more
              </p>

              <div className={styles.formbox}>
                <Card className={styles.formCard}>
                  {step === 1 && (
                    <Form onSubmit={handleMobileSubmit}>
                      <h5 className={styles.formHeading}>
                        Enter Mobile Number
                      </h5>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="tel"
                          placeholder="10-digit Mobile Number"
                          value={mobile}
                          onChange={(e) =>
                            setMobile(e.target.value.replace(/\D/, ""))
                          }
                          maxLength={10}
                          className={styles.formInput}
                          required
                        />
                      </Form.Group>
                      <Button type="submit" className={styles.formButton}>
                        Send OTP
                      </Button>
                    </Form>
                  )}

                  {step === 2 && (
                    <Form onSubmit={handleOtpSubmit}>
                      <h5 className={styles.formHeading}>Enter OTP</h5>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="4-digit OTP"
                          value={otp}
                          onChange={(e) =>
                            setOtp(e.target.value.replace(/\D/, ""))
                          }
                          maxLength={4}
                          className={`${styles.formInput} ${styles.otpInput}`}
                          required
                        />
                      </Form.Group>
                      <Button type="submit" className={styles.formButton}>
                        Verify OTP
                      </Button>
                    </Form>
                  )}

                  {step === 3 && (
                    <Form onSubmit={handleFinalSubmit}>
                      <h5 className={styles.formHeading}>Your Details</h5>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Full Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          className={styles.formInput}
                          required
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="email"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className={styles.formInput}
                          required
                        />
                      </Form.Group>
                      <Button type="submit" className={styles.formButton}>
                        Submit
                      </Button>
                    </Form>
                  )}
                </Card>
              </div>
            </div>
          </div>
          <div className={styles.containercol2}>
            <Image src={man} alt="men" className={styles.imggirl} />
          </div>
        </div>
      </div>

      {/* <LoginModal show={showModal} handleClose={() => setShowModal(false)} /> */}
    </div>
  );
}
